import { useState } from "react";
import { toast } from "sonner";
import { Video, Trash2, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const MAX = 50 * 1024 * 1024;

export function VideoEditor({ talentId, hasVideo, uploadedAt, onSaved }) {
  const [progress, setProgress] = useState(null);
  const [cacheBust, setCacheBust] = useState(0);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > MAX) return toast.error("Ukuran video maksimal 50 MB");
    const fd = new FormData();
    fd.append("video", file);
    setProgress(0);
    try {
      const { data } = await api.post("/talent/me/video", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000, onUploadProgress: (ev) => setProgress(ev.total ? Math.round((ev.loaded / ev.total) * 100) : 0) });
      toast.success("Video perkenalan tersimpan");
      setCacheBust((n) => n + 1);
      onSaved(data);
    } catch (err) { toast.error(errMsg(err)); } finally { setProgress(null); }
  };

  const remove = async () => {
    if (!window.confirm("Hapus video perkenalan?")) return;
    try { const { data } = await api.delete("/talent/me/video"); toast.success("Video dihapus"); onSaved(data); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="card-soft p-5" data-testid="video-editor">
      <p className="font-heading font-medium text-slate-800 inline-flex items-center gap-2"><Video size={16} strokeWidth={1.5} className="text-primary" />Video perkenalan</p>
      <p className="mt-1 text-sm text-slate-500 leading-relaxed">Tampil di kartu "Detail Talent" pada profil publik. MP4/WEBM/MOV, maks. 50 MB, disarankan 30-60 detik.</p>
      {hasVideo && (
        <video key={cacheBust} controls preload="metadata" className="mt-3 w-full max-h-56 rounded-lg bg-black" src={`${process.env.REACT_APP_BACKEND_URL}/api/talents/${talentId}/video?v=${cacheBust}`} data-testid="video-preview" />
      )}
      {hasVideo && <p className="mt-2 text-xs text-slate-500" data-testid="video-status">Diunggah {new Date(uploadedAt).toLocaleDateString("id-ID")}</p>}
      {progress !== null && (
        <div className="mt-3" data-testid="video-progress"><div className="h-2 rounded-full bg-secondary overflow-hidden"><div className="h-full bg-primary transition-[width]" style={{ width: `${progress}%` }} /></div><p className="mt-1 text-xs text-slate-500">Mengunggah {progress}%</p></div>
      )}
      <div className="mt-3 flex gap-2 flex-wrap">
        <label className={`btn-outline h-10 px-4 text-sm cursor-pointer ${progress !== null ? "opacity-50 pointer-events-none" : ""}`}>
          <Upload size={14} strokeWidth={1.5} />{hasVideo ? "Ganti video" : "Unggah video"}
          <input type="file" className="hidden" accept="video/mp4,video/webm,video/quicktime" onChange={upload} data-testid="video-file" />
        </label>
        {hasVideo && <button onClick={remove} className="btn-ghost h-10 text-sm text-rose-700 hover:bg-rose-50" data-testid="video-delete"><Trash2 size={14} strokeWidth={1.5} />Hapus</button>}
      </div>
    </div>
  );
}
